//------------- ROTAS ---------

//importações
import React from "react";
import { useState, useEffect } from "react";
import "./styles.css";

import { Link } from "react-router-dom";
import Requests from "../../services/requests";
import toast, { Toaster } from "react-hot-toast";

//icons
import { FaPencilAlt } from "react-icons/fa";

//components
import ColorPicker from "../../components/picker-color";
import RoundedButton from "../../components/btn-rounded";
import DatagridRotas from "../../components/datagrid-rotas";
import { FiArrowLeft } from "react-icons/fi";

//componente
const Rotas = ({ token, id_usuario, setObservaRota, observaRota }) => {
	const [selected, setSelected] = useState({}); //rota selecionada do datagrid
	const [picking, setPicking] = useState(false); //verifica se alguma cor está sendo escolhida

	const [nome, setNome] = useState("");
	const [descricao, setDescricao] = useState("");
	const [pickedColor, setPickedColor] = useState(""); //cor escolhida para a rota

	const clearForm = () => {
		setNome("");
		setDescricao("");
		setPickedColor("");
		setSelected({});
	};

	//enviar o formulário para a api
	const handleSubmit = async (e) => {
		e.preventDefault();
		let config = { headers: { "x-access-token": token } };
		let object = {
			id_usuario: id_usuario,
			nome: nome,
			descricao: descricao,
			cor: pickedColor.toLowerCase(),
		};
		//verifica se algum item foi selecionado, caso tenha sido,
		//será chamada a rota de put (edição),
		//caso nenhum item tenha sido selecionado, cadastra um novo
		if (!selected.id) {
			await Requests.postRotas(object, config)
				.then((res) => {
					if (res.affectedRows > 0) {
						toast.success("Rota cadastrada com sucesso!");
						setObservaRota(!observaRota);
						clearForm();
					} else {
						toast.error("Não foi possível cadastrar a rota");
					}
				})
				.catch((err) => {
					toast.error("Não foi possível cadastrar a rota");
					console.log(err);
				});
		} else {
			object = { ...object, id: selected.id };
			await Requests.putRotas(object, config)
				.then((res) => {
					if (res.affectedRows > 0) {
						toast.success("Rota editada com sucesso!");
						clearForm();
					} else {
						toast.error("Não foi possível editar a rota");
					}
				})
				.catch((err) => {
					toast.error("Não foi possível editar a rota");
					console.log(err);
				});
		}
	};

	useEffect(() => {
		handleSelect();
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [selected]);

	//seleciona um item e envia para o form
	const handleSelect = () => {
		if (selected) {
			if (selected.nome) {
				setNome(selected.nome);
			} else {
				setNome("");
			}
			if (selected.descricao) {
				setDescricao(selected.descricao);
			} else {
				setDescricao("");
			}
			if (selected.cor) {
				setPickedColor(selected.cor);
			} else {
				setPickedColor("");
			}
		}
	};
	const handleClear = () => {
		setSelected({});
	};

	return (
		<div className="div-body-rotas-component">
			<div>
				<Toaster />
			</div>
			<Link className="txt-button voltar" to={"/agenda"}>
				<FiArrowLeft /> Voltar
			</Link>
			<label className="txt-title">Rotas - {Object.values(selected).length > 0 ? "Edição" : "Cadastro"}</label>
			<form onSubmit={(e) => handleSubmit(e)}>
				{/* formulário de cadastro de usuário */}
				<div className="form">
					<div className="input-divs">
						<div>
							{Object.values(selected).length > 0 ? (
								<label>Nome</label>
							) : (
								<label>Nova rota</label>
							)}
							<input
								required
								id="nome"
								name="nome"
								value={nome}
								onChange={(e) => {
									setNome(e.target.value);
								}}
								maxLength={200}
								type="text"
								className="input-text"
								placeholder="Nome"
							></input>
						</div>
						<div id="colorpicker">
							<label id="label-cor">Cor</label>
							<div
								onClick={() => {
									setPicking(!picking);
								}}
								style={{
									fontFamily: "var(--font-primary)",
									transition: "all 0.2s ease-in-out",
									color: pickedColor
										? pickedColor === "#ffffff"
											? "black"
											: "white"
										: "var(--color-primary)",
									padding: 10,
									display: "flex",
									justifyContent: "center",
									backgroundColor: pickedColor,
									borderBottomWidth: 5,
									borderRadius: 500,
									cursor: "pointer",
								}}
							>
								<FaPencilAlt />

								{/* <ColorPicker
                  setValor={setPickedColor}
                  valor={pickedColor}
                ></ColorPicker> */}
							</div>
							{picking ? (
								<ColorPicker
									setValor={setPickedColor}
									valor={pickedColor}
								></ColorPicker>
							) : (
								<></>
							)}
						</div>
					</div>
					<div className="div-txt-area">
						<label>Descrição</label>
						<textarea
							id="descricao"
							name="descricao"
							value={descricao}
							onChange={(e) => {
								setDescricao(e.target.value);
							}}
							maxLength={500}
							className="input-text"
							placeholder="..."
						></textarea>
					</div>
					<div className="buttons">
						<RoundedButton
							event={handleClear}
							text={"Limpar"}
							stl="yellow-button"
						></RoundedButton>
						<RoundedButton
							type="submit"
							text={Object.values(selected).length > 0 ? "Salvar" : "Cadastrar"}
						></RoundedButton>
					</div>
				</div>
				{/* exibe o datagrid com as informações recebidas */}
				<div className="datagrid">
					<DatagridRotas
						token={token}
						id_usuario={id_usuario}
						setSelectedItem={setSelected}
						setObservaRota={setObservaRota}
						observaRota={observaRota}
					></DatagridRotas>
				</div>
			</form>
		</div>
	);
};

export default Rotas;
